import React, { useState, useEffect, useContext } from 'react';
import { useQuery, useApolloClient } from '@apollo/client';
import { getId, editswdConf, getSwdListsQuery, getSwdListsCntQuery, addSwdPackageQuery, addSwdPackageConfigurationQuery, deleteSwdPackage, getJsonSchemaQueryPackageDetails, getJsonSchemaQueryAppConfiguration, getJsonSchemaQueryAdvanceConfiguration, editswdForm, getswdForm, deleteConfignew, getJsonSchemaQueryAppConfigurationU, getPackageID } from "../../graphql/swd_queries";
import { async } from 'q';
import { v4 as uuidv4 } from 'uuid';
import path from 'path';
import { GlobalContext } from '../../hooks/globalContext';
import OverLay from '../../components/side_menu/overlay_side_menu.component';
import AppConfig from '../../utility/AppConfig';
import apiCall from '../../utility/api';
// import getStorageToken from '../utility/authUtils';


type dataProps = {
    [x: string]: any;
    data: any;
    func: any;
    searchVal: any
    pageNo: any
    setTotalPages: any
    setTotalRecords: any
    savePackageDetails?: any; // Making it optional
    setSavePackageDetails?: any
    deleteprofile: any
    setDeleteprofile: any
    setDeleteDisabled: any
    pkgId: any
    setJsonDataPkg: any
    setUiDataPkg: any
    setJsonDataApp: any
    setUiDataApp: any
    setJsonDataAdv: any
    setUiDataAdv: any
    formDataPkg: any
    formDataApp: any
    formDataAdv: any
    setFormDataPkg: any
    setFormDataApp: any
    setFormDataAdv: any
    rowID?: any
    overlayName?: any
    handleEditData?: any
    overlay?: any
    setOverlayOpen?: any
    setRowId?: any
    isFilter?: any
    dropDownValue1?: any
    dropDownValue2?: any
    setIsFilter?: any
    isRefresh?: any,
    setIsRefresh?: any
    setRefreshToast?: any
    setDelete?: any
    isDelete?: any
    status?: any
    setStatus?: any
    setExportDetails?: any
    rowconfID?: any
    setRowconfID?: any
    type?: any
    filterArray?: any
    setExportBtnClicked?: any
    exportBtnClicked?: any
    tenant?: any
    setExportConfigDetails?: any
    importSubmitClicked?: any
    setImportSubmitClicked?: any
    csvConfigurationList?: any
    csvPackageConfigurationList?: any
    setIsImportProgressLoading?: any
    setOverlayOpenNew?: any
    setMessage?: any
    setIsCommonToast?: any
    setIsProgressLoading?: any
    setSpinnerLoad?: any
}


export const Swd_func = (props: dataProps) => {
    const client = useApolloClient();
    const app_packageId = uuidv4();
    const [filesList, setFilesList] = useState([1])
    const [storageToken, setStorageToken] = useState('')
    const [isdeleteList, setDeleteList] = useState([]);
    // const[,setPackageId]:any = useState(null)
    let packageId: any;
    let deletelist: any = [];
    console.log("checking the FILESLIST STATE VALUE++++", filesList)
    const contextValue: any = useContext(GlobalContext);
    var tenantName = contextValue.tenantName;
    var userName = contextValue.userSessionDetails.userName;
    var selectedRowsID = contextValue.selectedRowIdInTable;
    var device_package: any = [];

    const getJsonSchemaQueryPkg = async () => {
        const dartid = 1501
        const { status, data } = await apiCall('/softDist/getJsonSchema', { dartid });
        if (status === 'success' && data.length > 0) {
            var uiSchema = JSON.parse(data?.[0]?.uiSchema);
            uiSchema["ui:submitButtonOptions"] = {
                "norender": true,
            };
            var jsondata = JSON.parse(data?.[0]?.jsonSchema);
            console.log("jsondata=", jsondata);
            (data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataPkg(jsondata);
            // (data?.core_DartJsonSchema?.[0]?.jsonSchema ?? null) !== null && props.setUiData(jsondata);
            // data?.core_DartJsonSchema[0]?.jsonSchema != undefined && props.setJsonData(jsondata);
            data?.[0]?.uiSchema != undefined && props.setUiDataPkg(uiSchema);
        }
    };

    const getJsonSchemaQueryApp = async () => {
        if (!props.status) {
            const dartid = props.type == 'Uninstallation' ? 1504 : 1502;
            const { status, data } = await apiCall('/softDist/getJsonSchema', { dartid });

            if (status === 'success' && data.length > 0) {
                var uiSchema = JSON.parse(data[0]?.uiSchema);
                uiSchema["ui:submitButtonOptions"] = {
                    "norender": true,
                };

                // get the list of files from s3 and set dropdown
                const headers = {
                    'x-auth-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOnRydWUsImlhdCI6MTcwOTEwMzk0NCwiZXhwIjoxNzA5MTA3NTQ0fQ.TrZ0b_SQ5kVQOkTItuuzz4HAZe7QpSZtTzmbw9IB0V8',
                    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                };
                const requestOptions = {
                    method: 'GET', // specify the HTTP method (GET, POST, etc.)
                    headers: headers,
                    // add other options like 'body' if needed
                };          //await fetch('http://localhost:5001/storage/api/getList',requestOptions)

                try {
                    const fileData = await apiCall('/softDist/getFiles')
                    // console.log("checking the data response from FILEAPI",data)
                    var list = await fileData.data.map((val: any) => val.Key)
                    console.log("check with LIST", list)
                    setFilesList(list)
                } catch (error: any) { console.error('Error fetching files:', error) };

                var jsonSchemaData = JSON.parse(data[0]?.jsonSchema);
                if (jsonSchemaData?.items?.allOf[0]?.dependencies?.Application_details?.oneOf[1]?.properties?.uploadApplication1) {
                    jsonSchemaData.items.allOf[0].dependencies.Application_details.oneOf[1].properties.uploadApplication1.enumNames = filesList;//map same thing at
                    jsonSchemaData.items.allOf[0].dependencies.Application_details.oneOf[1].properties.uploadApplication1.enum = filesList//both places.
                }
                console.log("jsonSchemaData=", jsonSchemaData);
                (data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataApp(jsonSchemaData);
                // data[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
                data[0]?.uiSchema != undefined && props.setUiDataApp(uiSchema);
            }
        } else {
            const dartid = props.type == 'Uninstallation' ? 1504 : 1502;
            const { status, data } = await apiCall('/softDist/getJsonSchema', { dartid });
            if (status === 'success' && data.lenght > 0) {
                var uiSchema = JSON.parse(data[0]?.uiSchema);
                uiSchema["ui:submitButtonOptions"] = {
                    "norender": true,
                };
                var jsonSchemaData = JSON.parse(data[0]?.jsonSchema);
                console.log("jsonSchemaData=", jsonSchemaData);
                (data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataApp(jsonSchemaData);
                // data[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
                data[0]?.uiSchema != undefined && props.setUiDataApp(uiSchema);
            }
        }
    };

    const getJsonSchemaQueryAdv = async () => {
        const dartid = 1503;
        const { status, data } = await apiCall('/softDist/getJsonSchema', { dartid });
        if (status === "success" && data.length > 0) {
            var uiSchema = JSON.parse(data?.[0]?.uiSchema);
            uiSchema["ui:submitButtonOptions"] = {
                "norender": true,
            };
            var jsonSchemaData = JSON.parse(data?.[0]?.jsonSchema);
            console.log("jsonSchemaData=", jsonSchemaData);
            (data?.[0]?.jsonSchema ?? null) !== null && props.setJsonDataAdv(jsonSchemaData);
            // data?.core_DartJsonSchema[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
            data?.[0]?.uiSchema != undefined && props.setUiDataAdv(uiSchema);
        }
    };

    const getSwdList = async (whereCondition: any, limit: Number, offset: Number) => {
        try {
            let { data, status } = await apiCall('/softDist/getSwd', { ...whereCondition, limit, offset });
            if (status === 'success') {
                props.func(data);
            } else {
                props.func(data);
            }
            console.log('apiData=', data);
        } catch (error) {
            console.log('getSWdList error=', error);
        }
    };

    const getSwdListCnt = async (whereCondition: any) => {
        try {
            let { data, status } = await apiCall('/softDist/getSwdCount', { ...whereCondition });
            if (status === 'success' && data.totalRecords > 0) {
                props?.setTotalRecords(data.totalRecords);
                props?.setTotalPages(data.totalPages);
            } else {
                props?.setTotalRecords(0);
                props?.setTotalPages(1);
            }
        } catch (error) {
            console.log("getCensusListsCnt error=", error);
            props?.setTotalRecords(0);
            props?.setTotalPages(1);
        }
    };

    //CONFIGURATION APPENDING TO A PARTICULAR FORMAT 32bit and 64 bit
    // example confStrDownload_32 = 
    //  1,NT,https://deployment-static-storage.s3.amazonaws.com/41-qbzkbibgygxq/softdist/7z2201-x32.exe,0,0,4,C:\Program Files\Nanoheal\Client\Tools\Scripts\

    const getForm = async () => {
        const app_packageId = props.rowID;
        try {
            const { data, status } = await apiCall('/softDist/getPackagesFormData', { app_packageId });
            if (status === "success") {
                props.setSpinnerLoad(false);
                props.handleEditData(data);
            }
        } catch (error) {
            console.error("An unexpected error occurred:", (error as Error).message);
            // Handle unexpected errors, log them, and potentially notify the user
        }
    };

    const addSwdPackage = async () => {
        const swdData = {
            formDataPkg: props?.formDataPkg,
            formDataAdv: props?.formDataAdv,
            formDataApp: props?.formDataApp,
            overlayName: props?.overlayName,
            status: props?.status,
            rowID: props?.rowID,
            app_packageId: app_packageId,
            rowconfID: props?.rowconfID
        }
        try {
            let data = await apiCall('/softDist/addSwdPackage', { swdData });
            if (data.status === 'success') {
                props.func(data);
            }
            console.log('apiData=', data);
        } catch (error) {
            console.log('getSWdList error=', error);
        }
    };// end of addSwdPackage function

    ///getid////////////////
    const getIds = async () => {
        let tempdel: any = [];
        try {
            for (const id of selectedRowsID) {
                const { data, loading, error } = await client.query({
                    query: getId,
                    variables: { selectedRowsID: id },
                    fetchPolicy: 'network-only',
                });
                if (!loading && data) {
                    console.log("checking the packageId here", data.softinst_Packages[0].id)
                    tempdel.push(data?.softinst_Packages[0]?.id)
                    console.log("packaging set", deletelist);
                }
            }
            setDeleteList(tempdel);
            console.log(isdeleteList);
        }
        catch (error) {
            console.error("An error occurred:", error);
        }

    };
    ////////deleteQuery/////
    const delConfNew = async () => {
        try {
            console.log("packaging set inside delete cofig", isdeleteList);
            const { data } = await client.mutate({
                mutation: deleteConfignew,
                variables: { isdeleteList },
                fetchPolicy: "network-only",
            });

            if (data.delete_softinst_Packages?.affected_rows > 0) {
                // props.setDeleteDisabled(true);
                // props.setDeleteprofile(false);
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    const delSwdprofile = async (whereCondition: any) => {
        try {
            // const  app_packageIdDelete = _eq;
            const data = await apiCall('/softDist/deleteSwdPackage', whereCondition);
            if (data.status === 'success') {
                console.log('delete data successful');
                // getSwdList({ status: props.type }, 50, parseInt(props.pageNo));
                // getSwdListCnt({ status: props.type });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const delSwdprofileConfig = async (whereCondition: any) => {
        try {
            // const  app_packageIdDelete = _eq;
            const data = await apiCall('/softDist/deleteSwdPackageConfig', whereCondition);
            if (data.status === 'success') {
                props.setIsProgressLoading(false);
                console.log('delete data successful');
                props.setMessage({
                    type: 'success',
                    text: 'Data Deleted Successfully'
                });
                props.setIsCommonToast(true);
                setTimeout(() => {
                    props.setIsCommonToast(false);
                }, 3000);
                // getSwdList({ status: props.type }, 50, parseInt(props.pageNo));
                // getSwdListCnt({ status: props.type });
            } else {
                props.setIsProgressLoading(false);
                props.setMessage({
                    type: 'failure',
                    text: 'Delete operation failed!'
                });
                props.setIsCommonToast(true);
                setTimeout(() => {
                    props.setIsCommonToast(false);
                }, 3000);
            }
        } catch (error) {
            props.setIsProgressLoading(false);
            props.setMessage({
                type: 'error',
                text: 'Some error occured with delete operation!'
            });
            props.setIsCommonToast(true);
            setTimeout(() => {
                props.setIsCommonToast(false);
            }, 3000);
            console.log('error', error);
        }
    };

    const sendImportedData = async (csvConfigurationList: any, csvPackageConfigurationList: any) => {
        const importData = {
            configurationList: csvConfigurationList,
            packageConfigurationList: csvPackageConfigurationList
        }
        try {
            const data = await apiCall('/softDist/importConfigurations', importData);
            props.setIsImportProgressLoading(false);
            if (data.status === 'success') {
                console.log('importing data successful');
                props.setIsImportProgressLoading(false);
                props.setOverlayOpenNew(false);
                props.setMessage({
                    type: 'success',
                    text: 'Configuration import successful!'
                });
                props.setIsCommonToast(true);
                setTimeout(() => {
                    props.setIsCommonToast(false);
                }, 3000);
                getSwdList({ status: props.type }, 50, parseInt(props.pageNo));
                getSwdListCnt({ status: props.type });
            } else {
                props.setMessage({
                    type: 'failure',
                    text: 'Configuration import failed'
                });
                props.setIsCommonToast(true);
                setTimeout(() => {
                    props.setIsCommonToast(false);
                }, 3000);
                props.setOverlayOpenNew(false);
            }
        } catch (error) {
            props.setIsImportProgressLoading(false);
            props.setOverlayOpenNew(false);
            console.log('error', error);
            props.setMessage({
                type: 'failure',
                text: error
            });
            props.setIsCommonToast(true);
            setTimeout(() => {
                props.setIsCommonToast(false);
            }, 3000);
        }
    }

    const getDownloadableLink = (filepath: string) => {
        return `${process.env.REACT_APP_STORAGE_URL}/storage/${filepath}`
    }


    useEffect(() => {
        //get jwt token for authentication of storage service
        // getStorageToken()
        if (props.deleteprofile && contextValue.selectedRowIdInTable.length > 0) {
            const ids = contextValue.selectedRowIdInTable.map(item => item.split(' : ')[0]);
            const uuids = contextValue.selectedRowIdInTable.map(item => item.split(' : ')[1]);
            console.log('ids : ', ids)
            console.log('uuids : ', uuids)
            delSwdprofile(uuids);
            delSwdprofileConfig(ids);
            // delConfNew();
            console.log(' delConfNew props.rowID :' + props.rowID);
            contextValue.setSelectedRowIdInTable([])
            setTimeout(() => {
                // props.setDeleteDisabled(true);
                props.setDeleteprofile(false);
            }, 3000);
            // getSwdList({ status: props.type },50,parseInt(props.pageNo));
            // getSwdListCnt({ status: props.type});
        }/*else if (props.importSubmitClicked) {
            sendImportedData(props.csvConfigurationList, props.csvPackageConfigurationList);
            // Reset the export button clicked state
            props.setImportSubmitClicked(false);
        }*/
        else {
            // getSwdList({ status: props.type},50,parseInt(props.pageNo));
            // getSwdListCnt({ status: props.type});
            getJsonSchemaQueryPkg();
            getJsonSchemaQueryApp();
            getJsonSchemaQueryAdv();
        }
        if (props.searchVal.length > 0 && props.searchVal !== '') {
            getSwdList({ status: props.type, search: props.searchVal, type: 'search' }, 50, parseInt(props.pageNo))
            getSwdListCnt({ status: props.type, search: props.searchVal, type: 'search' });
        } else if (props.isFilter == true) {
            getSwdList({ filter: props.filterArray, status: props.type, type: 'filter' }, 50, props.pageNo);
            getSwdListCnt({ filter: props.filterArray, status: props.type, type: 'filter' });
        } else {
            getSwdList({ status: props.type }, 50, parseInt(props.pageNo));
            getSwdListCnt({ status: props.type });
        }

        if (props.savePackageDetails == true && props.overlayName != "editInstallation") {
            addSwdPackage();
            // setTimeout(() => {
            //     getSwdList({ status: props.type }, 50, parseInt(props.pageNo));
            //     getSwdListCnt({ status: props.type });
            // }, 2000);
            props.setSavePackageDetails(false);
            props.setFormDataPkg(null)
            props.setFormDataApp(null)
            props.setJsonDataAdv(null)
            props.setRowId(null)
        }
        if (props.overlayName != "editInstallation") {
            props.setFormDataPkg(null)
            props.setFormDataApp(null)
            props.setFormDataAdv(null)
            props.setRowId(null)
        }

        if (props.savePackageDetails == true && props.overlayName == "editInstallation") {
            addSwdPackage();
            // setTimeout(() => {
            //     getSwdList({ status: props.type},50,parseInt(props.pageNo));
            //     getSwdListCnt({ status: props.type });
            // }, 2000);
            props.setSavePackageDetails(false);
            props.setFormDataPkg({})
            props.setFormDataApp({})
            props.setFormDataAdv({})
        }
    }, [props.searchVal, props.pageNo, props.savePackageDetails, props.deleteprofile, props.overlayName, props.formValidation, props.isFilter, props.filterArray]);
    useEffect(() => {
        if (props.rowID) {
            props.setFormDataPkg({});
            props.setFormDataAdv({});
            props.setFormDataApp({});
            getForm();
        }
    }, [props.rowID]);

    useEffect(() => {
        if (props.importSubmitClicked) {
            sendImportedData(props.csvConfigurationList, props.csvPackageConfigurationList);
            // Reset the export button clicked state
            props.setImportSubmitClicked(false);
        }
    }, [props.importSubmitClicked])

    useEffect(() => {
        if (props.exportBtnClicked) {
            // Trigger both export data API calls
            const fetchExportData = async () => {
                try {
                    // First API call for export details
                    const exportResponse = await apiCall('/softDist/getSwd', {
                        function: 'export',
                        tenant: props.tenant,
                        status: props.type
                    });

                    // Extract IDs from exportResponse.data
                    const app_packageId = exportResponse.data.map(item => item.id);

                    // Second API call for configuration details
                    const configResponse = await apiCall('/softDist/getPackagesFormData', { app_packageId });

                    // Check if both calls were successful
                    if (exportResponse.status === 'success' && configResponse.status === 'success') {
                        // Set the export details
                        props.setExportDetails(exportResponse.data || []);
                        props.setExportConfigDetails(configResponse.data || []);
                    } else {
                        // Handle error scenario
                        console.error('Export data fetch failed');
                    }
                } catch (error) {
                    console.error('Export data fetch error:', error);
                } finally {
                    // Reset export button state
                    props.setExportBtnClicked(false);
                }
            };

            // Call the async function
            fetchExportData();
        }
        if (props.isRefresh) {
            getSwdList({ status: props.type }, 50, parseInt(props.pageNo));
            getSwdListCnt({ status: props.type });
        }
    }, [props.exportBtnClicked, props.isRefresh]);

    return (
        <></>
    )
}